module.exports = __webpack_public_path__ + "static/media/bth.ff012d24.png";